import { useTranslation } from "react-i18next";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { RolePill, type RoleKind } from "@/components/vroom/role-pill";

export interface AccountSectionUser {
  firstName: string;
  lastName: string;
  email: string;
  erpId?: string;
  role: RoleKind;
}

export interface AccountSectionProps {
  user: AccountSectionUser;
}

export function AccountSection({ user }: AccountSectionProps) {
  const { t } = useTranslation();
  const initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`;
  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Avatar className="size-12">
          <AvatarFallback initials={initials} />
        </Avatar>
        <div>
          <div className="font-semibold text-ink-900">
            {user.firstName} {user.lastName}
          </div>
          <div className="text-[12px] text-ink-500">{user.email}</div>
          {user.erpId ? (
            <div className="font-mono text-[12px] text-ink-500">
              {t("profile-dialog.account.erp-prefix", { id: user.erpId })}
            </div>
          ) : null}
        </div>
      </div>
      <div>
        <span className="font-mono text-[9.5px] uppercase tracking-[.12em] text-ink-500">
          {t("profile-dialog.account.role-heading")}
        </span>
        <div className="mt-1">
          <RolePill role={user.role} />
        </div>
      </div>
    </div>
  );
}
